import { textoDeSinLeer } from "@/lib/textoDeSinLeer";

/**
 * Número de avisos sin leer sobre el avatar: «1» … «9+» (auditoría del perito
 * T04-09: en el móvil y la tableta solo había un punto rojo, sin cuántos).
 */
export function UnreadBadge({ count }: { count: number }) {
  const texto = textoDeSinLeer(count);
  if (!texto) return null;
  return (
    <span
      data-testid="unread-badge"
      className="pointer-events-none absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 ring-2 ring-white/80 text-white text-[10px] font-bold leading-[18px] text-center"
    >
      {texto}
    </span>
  );
}
